import { FunctionComponent } from "react";
import { useFormState } from "react-hook-form";
import { StyledCol, StyledRow } from "./buttons.styles";
import Grid from "components/grid/grid";
import Button from "components/button";
import { FormValues } from "lib/form";
import { ButtonType } from "components/button.styles";
import { IconType } from "components/icon-library";

export interface FormButtonInterface {
  text: string;
  type?: ButtonType;
  align?: "left" | "right" | "full";
  preIcon?: IconType;
  postIcon?: IconType;
  form?: string;

  // can be set disabled externally, usually submit buttons follow their own logic
  disabled?: boolean;

  // if the button saves the values, hence it must be validated
  submit?: boolean;

  // every button will have onClick
  // if the button has submit === true, the onClick will receive formValues
  onClick?: (formValues?: FormValues) => Promise<void>;
}

interface FormButtonProps {
  buttons: FormButtonInterface[];
}

const FormButtons: FunctionComponent<FormButtonProps> = ({ buttons }) => {
  const { isSubmitting, isValid } = useFormState();

  return (
    // must have it's own grid to prevent layout mistake with the grid above
    <Grid>
      <StyledRow>
        {buttons.map((button, index) => {
          const {
            preIcon,
            postIcon,
            text,
            align = "left",
            type = "primary",
            submit = false,
            form,
            disabled = false,
            onClick,
          } = button;

          // submit button is disabled if submitting, otherwise use the prop
          let isDisabled = disabled;

          // disable submit buttons while submitting
          if (!isDisabled && submit) {
            isDisabled = isSubmitting;
          }

          // disable submit buttons on invalid forms
          if (!isDisabled && submit) {
            isDisabled = !isValid;
          }

          return (
            <StyledCol key={`${index}-${text}`} $align={align}>
              <Button
                disabled={isDisabled}
                submit={submit}
                type={type}
                preIcon={preIcon}
                postIcon={postIcon}
                onClick={submit ? undefined : onClick}
                form={form}
              >
                {text}
              </Button>
            </StyledCol>
          );
        })}
      </StyledRow>
    </Grid>
  );
};

export default FormButtons;
